import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { getAppDotOrigin } from '../../../util'
import { Container, Icon, Input } from './styled'
import Select from './Select'

export default class Search extends Component {
  static contextTypes = {
    onSearch: PropTypes.func,
  }

  static redirect(searchText) {
    window.location.href = `${getAppDotOrigin()}/explore?searchText=${searchText}`
  }

  state = {
    value: '',
    scope: '',
  }

  onInputChange = e => {
    this.setState({
      value: e.currentTarget.value,
    })
  }

  onScopeChange = e => {
    this.setState(
      {
        scope: e.currentTarget.value,
      },
      () => {
        if (this.state.value.trim()) {
          this.submit()
        }
      }
    )
  }

  onKeyPress = e => {
    if (e.key === 'Enter') {
      this.submit()
    }
  }

  getScopedSearchText() {
    const { scope, value } = this.state
    const text = value.trim()

    return scope ? `${scope}:${text}` : text
  }

  submit = () => {
    if (!this.state.value.trim()) return

    const value = this.getScopedSearchText()
    const { onSearch } = this.context

    if (typeof onSearch === 'function') {
      onSearch(value)
    } else {
      Search.redirect(value)
    }
  }

  render() {
    const { value, scope } = this.state

    return (
      <Container>
        <Icon onClick={this.submit} />
        <Input
          type="text"
          name="searchText"
          value={value}
          onKeyPress={this.onKeyPress}
          onChange={this.onInputChange}
        />
        <Select value={scope} onChange={this.onScopeChange}>
          <option value="">All</option>
          <option value="upc">UPC</option>
        </Select>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/components/Header/Search/Search.js